<template>
  <div class="d-flex flex-column page-wrapper otherInformation">
    <page-header>
      <span v-if="jointBorrower == false"><span v-if="editMode">{{ $t("message.edit" )}}</span> {{ $t("message.otherInfo") }}</span>
      <span v-if="jointBorrower == true"><span v-if="editMode">{{ $t("message.edit" )}}</span> {{ $t("message.primaryApplicantOtherInfo" )}}</span>
    </page-header>
    <div class="container d-flex flex-column align-items-center page-container">
      <div class="d-flex flex-row justify-content-around steps-container">
        <div class="dot previous-dot"></div><!-- Identification -->
        <div class="dot previous-dot"></div><!-- Contact Info -->
        <div class="dot current-dot"></div><!-- Other Info -->
        <div class="dot next-dot" v-if="primaryReferenceRequired == true"></div><!-- References -->
        <div class="dot next-dot" v-if="jointBorrower == true"/><!-- Joint Identification -->
        <div class="dot next-dot" v-if="jointBorrower == true"/><!-- Joint Contact Info -->
        <div class="dot next-dot" v-if="jointBorrower == true"/><!-- Joint Other Info -->
        <div class="dot next-dot" v-if="jointBorrower == true && jointReferenceRequired == true"></div><!-- Joint References -->
        <div class="dot next-dot"></div><!-- Review -->
      </div>
      <p class="explanation-text" v-if="!verifiyingEligibility">
        We want to know just a little bit more about you.
      </p>
      <div class="d-flex flex-column justify-content-start align-items-start form-container" v-if="!verifiyingEligibility">
        <b-form @submit.prevent="submit" novalidate autocomplete="off">          
          <div v-if="employmentEligibility">
            <b-form-group class="form-label" label="Are you currently employed or retired?">
                <div class="switch-btn-container">
                  <label :for="$id('employmentSwitch')" class="switch-btn-left-label">No</label>
                  <b-form-checkbox class="switch-btn" v-model="isEmployed" :id="$id('employmentSwitch')" switch size="lg"></b-form-checkbox>
                  <label :for="$id('employmentSwitch')" class="switch-btn-right-label">Yes</label>
                </div>
                <div class="field-error-message" v-if="!$v.isEmployed.required && $v.isEmployed.$dirty">Please tell us whether you are currently employed</div>
            </b-form-group>
            <div v-if="isEmployed">
              <b-form-group class="form-label" label="Employer Name">                     
                <vue-typeahead-bootstrap type="text"  autocomplete="none" :id="$id('employerName')" backgroundVariant="light" v-model="employerName" :data="segCompanies"
                  :serializer="s => s.name" @hit="selectEmployer($event)" inputClass="form-control" ref="selectedEmployer">
                  <template slot="suggestion" slot-scope="{ data, htmlText }">
                    <div>
                      <span v-html="htmlText"></span>
                    </div>
                  </template>
                </vue-typeahead-bootstrap>
                <div v-if="retrievingSegCompanies">
                  Searching.. <img src="@/assets/img/light/activity.gif" class="processing-img-interim margin-top-20 margin-bottom-15" />   
                </div>
                <div class="field-error-message" v-if="!$v.employerName.required && $v.employerName.$dirty">Please enter the name of your employer</div>    
              </b-form-group>
              <b-form-group v-if="employerAddressRequired">
                  <label class="form-label more-info-section-header">Employment Address Information</label>
                  <div class="more-info-section">
                      <b-form-group class="form-label" label="Street Address">
                          <b-form-input type="text" :id="$id('address1')" v-model="address1"/>
                          <div class="field-error-message" v-if="!$v.address1.required && $v.address1.$dirty">Please enter employer street address.</div>
                      </b-form-group>
                      <b-form-group class="form-label" label="Address Line 2">
                          <b-form-input type="text" :id="$id('address2')" v-model="address2"/>        
                      </b-form-group>
                      <b-form-group class="form-label" label="City">
                          <b-form-input type="text" :id="$id('city')" v-model="city"/>        
                          <div class="field-error-message" v-if="!$v.city.required && $v.city.$dirty">Please enter employer City</div>        
                      </b-form-group>
                      <b-form-group class="form-label" label="State">
                          <b-form-select class="form-control" :id="$id('state')" v-model="state" :options="stateOptions"></b-form-select>
                          <div class="field-error-message" v-if="!$v.state.required && $v.state.$dirty">Please enter employer State</div>        
                      </b-form-group>
                      <b-form-group class="form-label" label="Zip Code">
                          <b-form-input type="tel" :id="$id('employerZipCode')" v-model="employerZipCode" v-mask="'#####', '#####-####'"/>        
                          <div class="field-error-message" v-if="!$v.employerZipCode.required && $v.employerZipCode.$dirty">Please enter your Zip Code</div>        
                          <div class="field-error-message" v-if="!$v.employerZipCode.zipCodeValidation && $v.employerZipCode.minLength && $v.employerZipCode.$dirty && $v.state.required">This Zip Code is not valid for the selected state</div>        
                          <div class="field-error-message" v-if="!$v.employerZipCode.minLength && $v.employerZipCode.$dirty">Please enter a valid Zip Code</div>        
                      </b-form-group>
                  </div>
              </b-form-group>
              <b-form-group class="form-label" label="Employment Type">
                  <b-button-group vertical class="btn-width" :id="$id('employmentTypes')">                        
                      <b-button variant="outline-primary" :pressed="option.value === employmentType" @click="selectEmploymentType(option)" v-for="option in employmentTypes" :key="option.value">{{ option.name }}</b-button>
                  </b-button-group>
                  <div class="field-error-message" v-if="!$v.employmentType.required && $v.employmentType.$dirty">Please select an employment type.</div>
              </b-form-group>
              <b-form-group class="form-label" label="Job Title">
                  <b-form-input :id="$id('jobTitle')" v-model="jobTitle"/>
                  <div class="field-error-message" v-if="!$v.jobTitle.required && $v.jobTitle.$dirty">Please enter your job title</div>   
              </b-form-group>
              <b-form-group class="form-label" label="Start Date">
                  <datepicker v-model="employmentStartDate" :id="$id('employmentStartDate')" format="MM/dd/yyyy" :input-class="{ 'form-control': true }" name="employmentStartDate" :typeable="true" v-mask="'##/##/####'"></datepicker> 
                  <div class="field-error-message" v-if="!$v.employmentStartDate.required && $v.employmentStartDate.$dirty">Please enter your Start Date</div>
              </b-form-group>
              <b-form-group class="form-label" label="Monthly Income">
                  <b-input-group>
                      <template #prepend>
                          <b-input-group-text><b>$</b></b-input-group-text>
                      </template>
                      <currency-input class="form-control" :id="$id('monthlyIncome')" inputmode="decimal" v-model="monthlyIncome" :currency="null"/>
                  </b-input-group>
                  <div class="field-error-message" v-if="!$v.monthlyIncome.required && $v.monthlyIncome.$dirty">Please enter your Gross Income</div>
              </b-form-group>
            </div>
            <div v-if="isEmployed && previousEmployments.length > 0">
              <b-form-group v-for="(item, index) in $v.previousEmployments.$each.$iter" :key="index">
                <label class="form-label more-info-section-header">Previous Employment Information</label>
                <div class="more-info-section previous-employment">
                  <b-form-group class="form-label" label="Employer Name">
                    <b-form-input type="text" :id="$id('employerName-'+index)" v-model="item.$model.employerName"/> 
                    <div class="field-error-message" v-if="!item.employerName.required && item.employerName.$dirty">Please enter the name of your employer</div>
                  </b-form-group>
                  <b-form-group>
                    <label class="form-label more-info-section-header">Address Information</label>
                    <div class="more-info-section">
                        <b-form-group class="form-label" label="Street Address">
                          <b-form-input type="text" :id="$id('address1-'+index)" v-model="item.$model.address1"/>        
                          <div class="field-error-message" v-if="!item.address1.required && item.address1.$dirty">Please enter employer street address.</div>
                          <div class="field-error-message" v-if="!item.address1.alphaNum && item.address1.$dirty">Street Addresses can only be letters and numbers</div>
                        </b-form-group>
                        <b-form-group class="form-label" label="Address Line 2">
                            <b-form-input type="text" :id="$id('address2-'+index)" v-model="item.$model.address2"/>        
                        </b-form-group>
                        <b-form-group class="form-label" label="City">
                          <b-form-input type="text" :id="$id('city-'+index)" v-model="item.$model.city"/>        
                          <div class="field-error-message" v-if="!item.city.required && item.city.$dirty">Please enter employer City</div>
                          <div class="field-error-message" v-if="!item.city.alphaDash && item.city.$dirty">Please enter a valid city name</div>  
                        </b-form-group>
                        <b-form-group class="form-label" label="State">
                          <b-form-select class="form-control" :id="$id('state-'+index)" v-model="item.$model.state" :options="stateOptions"></b-form-select>
                          <div class="field-error-message" v-if="!item.state.required && item.state.$dirty">Please enter employer State</div>        
                        </b-form-group>
                        <b-form-group class="form-label" label="Zip Code">
                            <b-form-input type="tel" :id="$id('zipCode-'+index)" v-model="item.$model.zipCode" v-mask="'#####', '#####-####'"/>        
                            <div class="field-error-message" v-if="!item.zipCode.required && item.zipCode.$dirty">Please enter your Zip Code</div>        
                            <div class="field-error-message" v-if="!item.zipCode.zipCodeValidation && item.zipCode.minLength && item.zipCode.$dirty && item.state.required">This Zip Code is not valid for the selected state</div>        
                            <div class="field-error-message" v-if="!item.zipCode.minLength && item.zipCode.$dirty">Please enter a valid Zip Code</div>        
                        </b-form-group>
                    </div>
                  </b-form-group>
                  <b-form-group class="form-label" label="Employment Type">
                      <b-button-group vertical class="d-flex flex-column" :id="$id('employmentTypes-'+index)">                        
                          <b-button variant="outline-primary" :pressed="option.value === item.$model.employmentType" @click="item.$model.employmentType = option.value" v-for="option in employmentTypes" :key="option.value">{{ option.name }}</b-button>
                      </b-button-group>
                      <div class="field-error-message" v-if="!item.employmentType.required && item.employmentType.$dirty">Please select an employment type.</div>
                  </b-form-group>
                  <b-form-group class="form-label" label="Job Title">
                      <b-form-input :id="$id('jobTitle-'+index)" v-model="item.$model.jobTitle"/>
                      <div class="field-error-message" v-if="!item.jobTitle.required && item.jobTitle.$dirty">Please enter your job title</div>   
                  </b-form-group>
                  <b-form-group class="form-label" label="Start Date">
                    <datepicker v-model="item.$model.employmentStartDate" :id="$id('employmentStartDate-'+index)" format="MM/dd/yyyy" :input-class="{ 'form-control': true }" :name="'employmentStartDate'+index" :typeable="true" v-mask="'##/##/####'"></datepicker> 
                    <div class="field-error-message" v-if="!item.employmentStartDate.required && item.employmentStartDate.$dirty">Please enter your Start Date</div>
                  </b-form-group>
                  <b-form-group class="form-label" label="End Date">
                    <datepicker v-model="item.$model.employmentEndDate" :id="$id('employmentEndDate-'+index)" format="MM/dd/yyyy" :input-class="{ 'form-control': true }" :name="'employmentEndDate'+index" :typeable="true" v-mask="'##/##/####'"></datepicker> 
                    <div class="field-error-message" v-if="!item.employmentEndDate.required && item.employmentEndDate.$dirty">Please enter your End Date</div>
                  </b-form-group>
                  <b-form-group class="form-label" label="Monthly Income">
                      <b-input-group>
                          <template #prepend>
                              <b-input-group-text><b>$</b></b-input-group-text>
                          </template>
                          <currency-input class="form-control" :id="$id('monthlyIncome-'+index)" inputmode="decimal" v-model="item.$model.monthlyIncome" :currency="null"/>
                      </b-input-group>
                      <div class="field-error-message" v-if="!item.monthlyIncome.required && item.monthlyIncome.$dirty">Please enter your Gross Income</div>
                  </b-form-group>
                  <b-button variant="dark" :id="$id('removeEmployment'+index)" @click.prevent="removePreviousEmployment(index)" class="d-flex justify-content-center align-items-center remove-btn">
                    <font-awesome-icon :icon="['fas', 'times']"></font-awesome-icon>
                    <span class="margin-left-10">{{ $t("message.remove" )}}</span>
                  </b-button>
                </div>
              </b-form-group>
            </div>
            <div v-if="isEmployed && additionalEmploymentRequired">
              <label class="form-label field-error-message margin-top-0">We need at least {{ minAddressHistoryInYears }} years of employment history. Click "Add Previous Employment" to add previous employment(s).</label>
              <b-button variant="primary" :id="$id('addEmployment')" @click="addPreviousEmployment()" class="d-flex justify-content-center align-items-center btn-width margin-bottom-15">
                  <font-awesome-icon :icon="['fas', 'plus']"></font-awesome-icon> 
                  <span class="margin-left-10">Add Previous Employment</span>
              </b-button> 
            </div>
            <div v-if="isEmployed">
              <b-form-group class="form-label margin-top-15" label="Do you have any other sources of income you would like to provide?">
                  <b-button-group vertical class="btn-width" :id="$id('additionalIncome')">                        
                      <b-button variant="outline-primary" :pressed="option.value === additionalIncome" @click="selectAdditionalIncome(option)" v-for="option in additionalIncomeOptions" :key="option.value">{{ option.name }}</b-button>
                  </b-button-group>
                  <div class="field-error-message" v-if="!$v.additionalIncome.required && $v.additionalIncome.$dirty">Please tell us whether you have other sources of income you would like to add.</div>
              </b-form-group>
              <div v-if="additionalIncome && !retrievingIncomeTypes">
                <b-form-group class="more-info-section additional-income" v-for="(item, index) in $v.additionalIncomeSources.$each.$iter" :key="index">
                  <label class="form-label more-info-section-header">
                    Alimony, child support, or separate maintenance income need not be revealed if you do not choose to have it considered
                  </label>
                  <div class="height-10"></div>
                  <b-form-group class="form-label" label="Income Source">
                    <b-button-group vertical :id="$id('additionalIncomeSource')" class="width-full">                        
                        <b-button variant="outline-primary" :pressed="option.coreId === item.$model.income" @click="selectIncomeSource(item.$model, option)" v-for="option in incomeSourceOptions" :key="option.coreId">{{ option.name }}</b-button>                                                
                    </b-button-group>
                    <div class="field-error-message" v-if="!item.income.required && item.income.$dirty">Please select the type of additional income</div>        
                  </b-form-group>
                  <b-form-group class="form-label" label="Monthly Income" v-if="item.$model.income">
                      <b-input-group>
                          <template #prepend>
                              <b-input-group-text><b>$</b></b-input-group-text>
                          </template>
                          <currency-input class="form-control" :id="$id('additionalIncomeAmount-'+index)" inputmode="decimal" v-model="item.$model.amount" :currency="null"/>
                      </b-input-group>
                      <div class="field-error-message" v-if="!item.amount.required && item.amount.$dirty">Please enter your additional income amount</div>
                  </b-form-group>
                  <b-form-group v-if="item.$model.name === 'Alimony'" class="form-label" label="How many months will you receive stated Alimony?">
                    <div class="d-flex flex-row">
                      <b-input-group append="Years">
                        <b-form-input type="number" :id="$id('alimonyYears-'+index)" v-model="item.$model.alimonyYears" min="0" class="width-50" />
                      </b-input-group>
                      <b-input-group append="Months">
                        <b-form-input type="number" :id="$id('alimonyMonths-'+index)" v-model="item.$model.alimonyMonths" min="0" max="11" class="width-50" />
                      </b-input-group>
                    </div>    
                  </b-form-group>
                  <b-form-group v-if="item.$model.name === 'Child Support'" class="form-label" label="How many months will you receive stated Child Support?">
                    <div class="d-flex flex-row">
                      <b-input-group append="Years">
                        <b-form-input type="number" :id="$id('childSupportYears-'+index)" v-model="item.$model.childSupportYears" min="0" class="width-50" />
                      </b-input-group>
                      <b-input-group append="Months">
                        <b-form-input type="number" :id="$id('childSupportMonths-'+index)" v-model="item.$model.childSupportMonths" min="0" max="11" class="width-50" />
                      </b-input-group>
                    </div>
                  </b-form-group>
                  <b-form-group v-if="item.$model.name === 'Other'" class="form-label" label="Please describe this income">
                    <b-form-input type="text" v-model="item.$model.description" :id="$id('additionalIncomeDesc-'+index)"/>
                  </b-form-group>
                  <p v-if="item.$model.name === 'Rental Income'">
                    <strong>This income must be verifiable with the last 2 years tax returns using the reported income from line 17 on form 1040</strong>
                  </p>
                  <b-button variant="dark" :id="$id('removeAdditionalIncome'+index)" @click.prevent="removeAdditionalIncome(index)" class="d-flex justify-content-center align-items-center remove-btn">
                    <font-awesome-icon :icon="['fas', 'times']"></font-awesome-icon>
                    <span class="margin-left-10">Remove Income Source</span>
                  </b-button>
                </b-form-group>
                <b-button variant="primary" :id="$id('addAdditionalIncome')" @click="addAdditionalIncome()" class="d-flex justify-content-center align-items-center btn-width margin-bottom-15">
                  <font-awesome-icon :icon="['fas', 'plus']"></font-awesome-icon> 
                  <span class="margin-left-10">Add Another Income Source</span>
              </b-button>
              </div>
              <div class="d-flex flex-column align-items-center align-content-center justify-content-center margin-bottom-20" v-if="retrievingIncomeTypes">   
                <img src="@/assets/img/light/activity.gif" class="processing-img-interim margin-top-15 margin-bottom-15" />
              </div>
            </div>
          </div>
          <div v-if="schoolEligibility && eligibilityRequired">
            <b-form-group class="form-label" label="Are you currently a student?">
                <div class="switch-btn-container">
                  <label :for="$id('studentSwitch')" class="switch-btn-left-label">No</label>
                  <b-form-checkbox class="switch-btn" v-model="isStudent" :id="$id('studentSwitch')" switch size="lg"></b-form-checkbox>
                  <label :for="$id('studentSwitch')" class="switch-btn-right-label">Yes</label>
                </div>
                <div class="field-error-message" v-if="!$v.isStudent.required && $v.isStudent.$dirty">Please tell us whether you are currently a student</div>
            </b-form-group>
            <div v-if="isStudent">
                <b-form-group class="form-label" label="School Name">
                    <b-form-input type="text" v-model="schoolName"/> 
                    <div class="field-error-message" v-if="!$v.schoolName.required && $v.schoolName.$dirty">Please enter the name of your school</div>               
                </b-form-group>
                <b-form-group class="form-label" label="What Zip Code do you currently attend school in?">
                    <b-form-input type="tel" :for="$id('schoolZipCode')" v-model="schoolZipCode" v-mask="'#####', '#####-####'"/>        
                    <div class="field-error-message" v-if="!$v.schoolZipCode.required && $v.schoolZipCode.$dirty">Please enter your school Zip Code</div>        
                    <div class="field-error-message" v-if="!$v.schoolZipCode.minLength && $v.schoolZipCode.$dirty">Please enter a valid Zip Code</div>        
                </b-form-group>
            </div>
          </div>
          <div v-if="worshipEligibility && eligibilityRequired">
            <b-form-group class="form-label" label="Do you currently attend worship locally?">
                <div class="switch-btn-container">
                  <label :for="$id('worshipSwitch')" class="switch-btn-left-label">No</label>
                  <b-form-checkbox class="switch-btn" v-model="attendsWorship" :id="$id('worshipSwitch')" switch size="lg"></b-form-checkbox>
                  <label :for="$id('worshipSwitch')" class="switch-btn-right-label">Yes</label>
                </div>
                <div class="field-error-message" v-if="!$v.attendsWorship.required && $v.attendsWorship.$dirty">Please tell us whether you attend worship locally</div>
            </b-form-group>
            <div v-if="attendsWorship">
                <b-form-group class="form-label" label="What Zip Code is your place of worship?">
                    <b-form-input type="tel" :for="$id('worshipZipCode')" v-model="worshipZipCode" v-mask="'#####', '#####-####'"/>        
                    <div class="field-error-message" v-if="!$v.worshipZipCode.required && $v.worshipZipCode.$dirty">Please enter your place of worship Zip Code</div>        
                    <div class="field-error-message" v-if="!$v.worshipZipCode.minLength && $v.worshipZipCode.$dirty">Please enter a valid Zip Code</div>        
                </b-form-group>
            </div>
          </div>
          <div v-if="volunteerEligibility && eligibilityRequired">
            <b-form-group class="form-label" label="Are you currently volunteering?">
                <div class="switch-btn-container">
                  <label :for="$id('volunteerSwitch')" class="switch-btn-left-label">No</label>
                  <b-form-checkbox class="switch-btn" v-model="isVolunteer" :id="$id('volunteerSwitch')" switch size="lg"></b-form-checkbox>
                  <label :for="$id('volunteerSwitch')" class="switch-btn-right-label">Yes</label>
                </div>
                <div class="field-error-message" v-if="!$v.isVolunteer.required && $v.isVolunteer.$dirty">Please tell us whether you are currently volunteering</div>
            </b-form-group>
            <div v-if="isVolunteer" >
              <b-form-group class="form-label" label="What Zip Code do you volunteer at?">
                <b-form-input type="tel" :for="$id('volunteerZipCode')" v-model="volunteerZipCode" v-mask="'#####', '#####-####'"/>        
                <div class="field-error-message" v-if="!$v.volunteerZipCode.required && $v.volunteerZipCode.$dirty">Please enter the Zip Code of where you volunteer</div>        
                <div class="field-error-message" v-if="!$v.volunteerZipCode.minLength && $v.volunteerZipCode.$dirty">Please enter a valid Zip Code</div>        
              </b-form-group>
            </div>
          </div>
          <div v-if="familyEligibilityAllowed && eligibilityRequired">
            <b-form-group>
              <label class="form-label">Do you have any family members who belong to {{ creditUnionName }}?</label>
                <div class="switch-btn-container">
                  <label :for="$id('familyEligibilitySwitch')" class="switch-btn-left-label">No</label>
                  <b-form-checkbox class="switch-btn" v-model="familyEligibility" :id="$id('familyEligibilitySwitch')" switch size="lg"></b-form-checkbox>
                  <label :for="$id('familyEligibilitySwitch')" class="switch-btn-right-label">Yes</label>
                </div>
                <div class="field-error-message" v-if="!$v.familyEligibility.required && $v.familyEligibility.$dirty">Please tell us whether you are currently a student</div>
            </b-form-group>
            <div v-if="familyEligibility">
                <b-form-group class="form-label" label="Family Member’s Name">
                    <b-form-input type="text" v-model="familyMemberName" />
                    <div class="field-error-message" v-if="!$v.familyMemberName.required && $v.familyMemberName.$dirty">Please enter the name of your family member</div>               
                </b-form-group>
                <b-form-group class="form-label" label="How are you related to this person?">
                    <b-form-input type="text" v-model="familyMemberRelationship" />
                    <div class="field-error-message" v-if="!$v.familyMemberRelationship.required && $v.familyMemberRelationship.$dirty">A relationship for your family member is required</div>        
                </b-form-group>
            </div>
          </div>
          <div v-if="donationEligibility && eligibilityRequired">
             <b-form-group>
                <label class="form-label">Would you like to donate {{ donationAmount | currency }} to the <a :href="donationFoundationUrl" target="_blank">{{ donationFoundation }}</a>?</label>
                <div class="switch-btn-container">
                  <label :for="$id('donationSwitch')" class="switch-btn-left-label">No</label>
                  <b-form-checkbox class="switch-btn" v-model="isDonating" :id="$id('donationSwitch')" switch size="lg"></b-form-checkbox>
                  <label :for="$id('donationSwitch')" class="switch-btn-right-label">Yes</label>
                </div>
                <div class="field-error-message" v-if="!$v.isDonating.required && $v.isDonating.$dirty">Please tell us whether you would like to donate money</div>
            </b-form-group>
            <!-- <div v-if="isDonating">
              <b-form-group class="form-label" label="How much would you like to donate at this time?">
                  <b-input-group>
                      <template #prepend>
                          <b-input-group-text><b>$</b></b-input-group-text>
                      </template>
                      <currency-input class="form-control" :for="$id('donationAmount')" inputmode="decimal" v-model="donationAmount" :currency="null" :disabled="true" />
                  </b-input-group>
                  <div class="field-error-message" v-if="!$v.donationAmount.required && $v.donationAmount.$dirty">Please enter your donation amount</div>
              </b-form-group>
            </div> -->
          </div>
          <div class="d-flex flex-column justify-content-between align-items-center final-action-div">
              <b-button variant="secondary" type="submit" :for="$id('next')" class="btn btn-width">
                  <span v-if="!editMode">{{ $t("message.next" )}}</span>
                  <span v-if="editMode">{{ $t("message.saveAndContinue" )}}</span>
              </b-button>
              <b-button variant="light" @click="back()" :for="$id('back')" class="btn btn-width">
                  <span v-if="!editMode || editedIdentificationInfo || editedContactInfo">{{ $t("message.back" )}}</span>
                  <span v-if="editMode && !editedIdentificationInfo  && !editedContactInfo">{{ $t("message.cancel" )}}</span>
              </b-button>
          </div>
        </b-form>
      </div> 
      <div class="d-flex flex-column align-items-center align-content-center justify-content-center form-container" v-if="verifiyingEligibility">            
        <p class="processing-text"></p>
        <img src="@/assets/img/light/activity.gif" class="processing-img" />                           
      </div>     
    </div>
    <page-footer />
    <b-modal ref="errorModalRef" body-text-variant="dark" header-text-variant="dark" centered ok-only ok-variant="secondary" title="Missing Information">{{ $t('message.missingRequiredFieldsMsg') }}</b-modal>
    <b-modal ref="notEligibleModalRef" body-text-variant="dark" header-text-variant="dark" centered ok-only ok-variant="secondary" hide-header>
      We're sorry, but it looks like you are not able to apply for a loan with {{ creditUnionName }}. Our applicants 
      live, work, go to school, and/or worship in our <a href="#">membership area</a>. If you have any questions please contact <a href="#">member services</a>.
    </b-modal>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import { required, requiredIf, decimal, minLength, helpers } from "vuelidate/lib/validators";
import { mask } from 'vue-the-mask';
import { zipCodeValidation } from "@/validators/validators.js";
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
const alphaNum = helpers.regex('alphaNum', /^[a-zA-Z0-9 ' . -]*$/);
const alphaDash = helpers.regex('alphaDash', /^[a-zA-Z ' . -]*$/);
import VueTypeaheadBootstrap from 'vue-typeahead-bootstrap';

export default {
  name: "OtherInformation",
  components: {
    Datepicker,
    VueTypeaheadBootstrap,
  },
  directives: {
    mask
  },
  props: {},
  created() {
    if(this.segEligibility) {
      this.getSegCompanies();
    }
  },
  mounted: function () {
    this.previousEmployments = this.primaryPreviousEmployments;
    this.additionalIncomeSources = this.primaryAdditionalIncomeSources;
    if(this.additionalIncome) {
      this.getEligibleIncomeTypes();
    }
  },
  watch: {
    employerName: function(value) {
      console.log('employer name changed', value);
        this.employerId = '';
    },
  },
  data: function() {
    return {
      employmentTypes: [
        { coreId: '1', name: 'Full Time', value: 'Full Time'},
        { coreId: '2', name: 'Part Time', value: 'Part Time'},
        { coreId: '3', name: 'Retired', value: 'Retired'},
      ],
      additionalIncomeOptions: [
        { name: 'Yes', value: true },
        { name: 'No', value: false }
      ],
      previousEmployments: [],
      additionalIncomeSources: [],
      verifiyingEligibility: false,
      incomeSourceOptions: [],
      retrievingIncomeTypes: false,
    };
  },
  computed: {
    ...mapState([
      "editMode",
      "currentState",
      "stateOptions",
      "creditUnion",
      "isJointApplication",
      "employmentEligibility",
      "schoolEligibility",
      "worshipEligibility",
      "volunteerEligibility",
      "donationEligibility",
      "familyEligibilityAllowed",
      "segEligibility",
      "primaryApplicant",
      "primaryAddress",
      "primaryEmployment",
      "primaryPreviousEmployments",
      "primarySchool",
      "primaryPlaceOfWorship",
      "primaryPlaceOfVolunter",
      "primaryDonationToFoundation",
      "minimumEmploymentHistoryMonths",
      "primaryAdditionalIncome",
      "primaryAdditionalIncomeSources",
      "retrievingSegCompanies",
      "segCompanies",
      'donationFoundation',
      'donationFoundationUrl',
      'donationAmount',
      'primaryFamilyMember',
      'primaryEligibilityId',
      'applicantEligibilityRequirement',
      'applicationEligibilityRequirement',
      'preventSubmission',
      'preventAutoApproval',
      'ignoreAndAddNote',
      'editedContactInfo',
      'challengeQuestionsEnabled'
    ]),
    ...mapGetters([
      'primaryEmploymentHistoryInMonths',
      "primaryReferenceRequired",
      "jointReferenceRequired",
    ]),
    creditUnionName: {
      get() {
        return this.creditUnion.name;
      }
    },
    jointBorrower: {
      get() {
        return this.isJointApplication;
      }
    },
    eligibilityId: {
      get() {
        return this.primaryEligibilityId;
      },
      set(value){
        this.updateEligiblityId({ isPrimary: true, eligibilityId: value });
      }
    },
    eligibilityRequired: {
      get() {
        return !this.eligibilityId;
      }
    },
    isEmployed: {
      get() {
        return this.primaryApplicant.isEmployed;
      },
      set(value) {
        this.updateApplicantEmploymentStatus({ isPrimary: true, isEmployed: value });
      }
    },
    employerAddressRequired: {
      get() {
        return this.employerId === '';
      },
    },
    employerId: {
      get() {
      console.log('employer id changed',  this.primaryEmployment.employerId);
        return this.primaryEmployment.employerId;
      },
      set(value) {        
        this.updateEmployerId({ isPrimary: true, isCurrentEmployment: true, employerId: value });
      }
    },
    employerName: {
      get() {
          return this.primaryEmployment.employerName;
      },
      set(value) {
          this.updateEmployerName({ isPrimary: true, isCurrentEmployment: true, employerName: value });
      }
    },            
    address1: {
      get() {
          return this.primaryEmployment.address1;
      },
      set(value) {
          this.updateEmployerAddress1({ isPrimary: true, isCurrentEmployment: true, address1: value });
      }
    },
    address2: {
      get() {
          return this.primaryEmployment.address2;
      },
      set(value) {
          this.updateEmployerAddress2({ isPrimary: true, isCurrentEmployment: true, address2: value });
      },
    },
    city: {
      get() {
          return this.primaryEmployment.city;
      },
      set(value) {
          this.updateEmployerCity({ isPrimary: true, isCurrentEmployment: true, city: value });
      }
    },
    state: {
      get() {
          return this.primaryEmployment.state;
      },
      set(value) {
          this.updateEmployerState({ isPrimary: true, isCurrentEmployment: true, state: value });
      }
    },
    employerZipCode: {
        get() {
            return this.primaryEmployment.zipCode;
        },
        set(value) {
            this.updateEmployerZipCode({ isPrimary: true, isCurrentEmployment: true, zipCode: value });
        }
    },
    employmentType: {
        get() {
            return this.primaryEmployment.employmentType;
        },
        set(value) {
            this.updateEmploymentType({ isPrimary: true, isCurrentEmployment: true, employmentType: value });
        }
    },
    jobTitle: {
        get() {
            return this.primaryEmployment.jobTitle;
        },
        set(value) {
            this.updateEmploymentJobTitle({ isPrimary: true, isCurrentEmployment: true, jobTitle: value });
        }
    },
    employmentStartDate: {
        get() {
          return this.primaryEmployment.employmentStartDate;
        },
        set(value) {
          this.updateEmploymentStartDate({ isPrimary: true, isCurrentEmployment: true, startDate: value });
        }
    },
    monthlyIncome: {
      get() {
        return this.primaryEmployment.monthlyIncome;
      },
      set(value) {
        this.updateEmploymentMonthlyIncome({ isPrimary: true, isCurrentEmployment: true, monthlyIncome: value });
      }
    },
    additionalIncome: {
      get() {
        return this.primaryAdditionalIncome;
      },
      set(value) {
        this.updateAdditionalIncome({ isPrimary: true, additionalIncome: value });
      }
    },
    isStudent: {
        get() {
            return this.primaryApplicant.isStudent;
        },
        set(value) {
            this.updateApplicantStudentStatus({ isPrimary: true, isStudent: value });
        }
    },
    schoolName: {
        get() {
            return this.primarySchool.schoolName;
        },
        set(value) {
            this.updateSchoolName({ isPrimary: true, schoolName: value });
        }
    },        
    schoolZipCode: {
        get() {
            return this.primarySchool.zipCode;
        },
        set(value) {
            this.updateSchoolZipCode({ isPrimary: true, zipCode: value });
        }
    },
    attendsWorship: {
        get() {
            return this.primaryApplicant.attendsWorship;
        },
        set(value) {
            this.updateApplicantWorshipStatus({ isPrimary: true, attendsWorship: value });
        }
    },
    worshipZipCode: {
        get() {
            return this.primaryPlaceOfWorship.zipCode;
        },
        set(value) {
            this.updatePlaceOfWorshipZipCode({ isPrimary: true, zipCode: value });
        }
    },
    isVolunteer: {
      get() {
          return this.primaryApplicant.isVolunteer;
      },
      set(value) {
          this.updateApplicantVolunteerStatus({ isPrimary: true, isVolunteer: value });
      }
    },
    volunteerZipCode: {
      get() {
          return this.primaryPlaceOfVolunter.zipCode;
      },
      set(value) {
          this.updatePlaceOfVolunteerZipCode({ isPrimary: true, zipCode: value });
      }
    },
    familyEligibility: {
        get() {
            return this.primaryApplicant.familyEligibility;
        },
        set(value) {
            this.updateApplicantFamilyEligibility({ isPrimary: true, familyEligibility: value });
        }
    },
    familyMemberName: {
        get() {
            return this.primaryFamilyMember.name;
        },
        set(value) {
            this.updateFamilyMemberName({ isPrimary: true, name: value });
        }
    },        
    familyMemberRelationship: {
        get() {
            return this.primaryFamilyMember.relationship;
        },
        set(value) {
            this.updateFamilyMemberRelationship({ isPrimary: true, relationship: value });
        }
    },
    isDonating: {
      get() {
          return this.primaryApplicant.isDonating;
      },
      set(value) {
          this.updateApplicantDonationStatus({ isPrimary: true, isDonating: value });
      }
    },
    // donationAmount: {
    //   get() {
    //       return this.primaryDonationToFoundation;
    //   },
    //   set(value) {
    //       this.updateDonationToFoundation({ isPrimary: true, donationToFoundation: value });
    //   }
    // },
    primaryAddressZipCode: {
      get() {
        return this.primaryAddress.zipCode;
      },
    },
    additionalEmploymentRequired() {
      if(this.primaryEmploymentHistoryInMonths < this.minimumEmploymentHistoryMonths) {
        if(this.previousEmployments.length == 0 && this.employmentStartDate) {
          return true;
        } else if(this.previousEmployments.length > 0
          && this.previousEmployments[this.previousEmployments.length-1].employmentStartDate) {
          return true;
        }
      }
      return false;
    },
    minAddressHistoryInYears() {
      return this.minimumEmploymentHistoryMonths / 12;
    },
    challengedQuestionsAnswered: {
      get() {
        return this.primaryApplicant.challengedQuestionsAnswered;
      }
    },
    editedIdentificationInfo: {
      get() {
        return this.$store.state.editedIdentificationInfo;
      },
      set(value) {
        this.updateEditedIdentificationInfo(value);
      }
    },
    contactInfoChanged: {
      get() {
        var prevPrimaryApplicant = this.currentState.primaryApplicant;
        var prevPrimaryAddress = this.currentState.primaryAddress;
        console.log("prev primary applicant", prevPrimaryApplicant);
        console.log("prev primary address", prevPrimaryAddress);
        console.log("primary applicant", this.primaryApplicant);
        console.log("primary address", this.primaryAddress);
        if(prevPrimaryApplicant.firstName !== this.primaryApplicant.firstName
          || prevPrimaryApplicant.lastName !== this.primaryApplicant.lastName
          || new Date(prevPrimaryApplicant.dateOfBirth).getTime() !== new Date(this.primaryApplicant.dateOfBirth).getTime()
          || prevPrimaryApplicant.taxId !== this.primaryApplicant.taxId
          || prevPrimaryAddress.address1 !== this.primaryAddress.address1
          || prevPrimaryAddress.address2 !== this.primaryAddress.address2
          || prevPrimaryAddress.city !== this.primaryAddress.city
          || prevPrimaryAddress.state !== this.primaryAddress.state
          || prevPrimaryAddress.zipCode !== this.primaryAddress.zipCode) {
            return true;
        }
      }
    }
  },
  methods: {
    ...mapActions([
        'getSegCompanies',
        'getIncomeTypes',
        'verifyEligibility',
    ]),
    ...mapMutations([
        'updateApplicantEmploymentStatus',
        'updateApplicantStudentStatus',
        'updateApplicantWorshipStatus',
        'updateApplicantVolunteerStatus',
        'updateApplicantDonationStatus',
        'updateEmployerId',
        'updateEmployerName',
        'updateEmployerAddress1',
        'updateEmployerAddress2',
        'updateEmployerCity',
        'updateEmployerState',
        'updateEmployerZipCode',
        'updateEmploymentType',
        'updateEmploymentJobTitle',
        'updateEmploymentStartDate',
        'updateEmploymentMonthlyIncome',
        'updateAdditionalIncome',
        'updateSchoolName',
        'updateSchoolZipCode',
        'updatePlaceOfWorshipZipCode',
        'updatePlaceOfVolunteerZipCode',
        'updateDonationToFoundation',
        'updateEligiblityId',
        'updateApplicantFamilyEligibility',
        'updateFamilyMemberName',
        'updateFamilyMemberRelationship',
        'updateEligiblityId',
        'updateEditedIdentificationInfo'
    ]),
    selectEmploymentType: function(opt) {
      this.employmentType = opt.value;
    },
    selectEmployer(event) {
      var employerId = event.coreId;
      var employer = this.segCompanies.find(item => item.coreId === employerId);
      if(employer) {
        this.employerName = employer.name;
        this.address1 = '';
        this.address2 = '';
        this.city = '';
        this.state = '';
        this.employerZipCode = '';        
        this.$nextTick(function () {
          //set the employer id after the name because setting the name will reset the employer id 
          this.employerId = employerId;
        });
      }
    },
    selectAdditionalIncome(opt) {
      this.additionalIncome = opt.value;
      if(this.additionalIncome) {      
        this.getEligibleIncomeTypes().then(() => {
          this.addAdditionalIncome();
        });
      } else {
        this.clearAdditionalIncome();
      }
    },
    async getEligibleIncomeTypes() {
      this.retrievingIncomeTypes = true;  
      this.getIncomeTypes().then((incomeTypes) => {
        this.retrievingIncomeTypes = false;
        this.incomeSourceOptions = incomeTypes;
      });
    },
    addAdditionalIncome() {
      let additionalIncome = {};
      additionalIncome.income = '';
      additionalIncome.name = '';
      additionalIncome.amount = null;
      additionalIncome.description = '';
      this.additionalIncomeSources.push(additionalIncome);
    },
    removeAdditionalIncome(index) {
      this.additionalIncomeSources.splice(index, 1);
      if(this.additionalIncomeSources.length === 0) {
        this.additionalIncome = false;
      }
    },
    clearAdditionalIncome() {
      this.additionalIncomeSources.length = 0;
    },
    selectIncomeSource(model, opt) {              
      model.income = opt.coreId; 
      model.name = opt.name; 
      model.type = {};                 
      model.type.typeId = opt.typeId;
    },
    addPreviousEmployment() {
      let previousEmployment = {};
      previousEmployment.employerId = '';
      previousEmployment.employerName = '';
      previousEmployment.address1 = '';
      previousEmployment.city = '';
      previousEmployment.state = '';
      previousEmployment.zipCode = '';
      previousEmployment.employmentType = '';
      previousEmployment.jobTitle = '';
      previousEmployment.employmentStartDate = null;
      previousEmployment.employmentEndDate = null;
      previousEmployment.monthlyIncome = null;
      this.previousEmployments.push(previousEmployment);
      this.$v.employmentStartDate.$reset();
    },
    removePreviousEmployment(index) {
      this.previousEmployments.splice(index, 1);
    },
    async submit() {
      this.$v.$touch();
      
      if(this.$v.$invalid) {
        this.$refs.errorModalRef.show();
      } else if(this.isEmployed && this.additionalEmploymentRequired) {
        this.$refs.errorModalRef.show();
      } else {
        this.verifiyingEligibility = true;
        
        let isEligible = this.eligibilityId && this.eligibilityId !== '';
        if(!isEligible && this.isEmployed) {
          if(this.employerId) {
            isEligible = true;
            var employer = this.segCompanies.find(item => item.coreId === this.employerId);
            this.eligibilityId = employer.accountEligibilitySerial;
          } else {
            let eligibleParams = {};
            eligibleParams.address1 = this.address1;
            eligibleParams.city = this.city;
            eligibleParams.state = this.state;
            eligibleParams.zipCode = this.employerZipCode;
            eligibleParams.isEmployment = true;      
            let response = await this.verifyEligibility(eligibleParams);
            if(response) {
              isEligible = response.isEligible;
              this.eligibilityId = response.eligibilityId;
            }
          }
        }
        if(!isEligible && this.isStudent) {
          let eligibleParams = {};
          eligibleParams.address1 = '';
          eligibleParams.city = '';
          eligibleParams.state = '';
          eligibleParams.zipCode = this.schoolZipCode;
          eligibleParams.isSchool = true;
          let response = await this.verifyEligibility(eligibleParams);
          if(response) {
            isEligible = response.isEligible;
            this.eligibilityId = response.eligibilityId;
          }
        }
        if(!isEligible && this.attendsWorship) {
          let eligibleParams = {};
          eligibleParams.address1 = '';
          eligibleParams.city = '';
          eligibleParams.state = '';
          eligibleParams.zipCode = this.worshipZipCode;
          eligibleParams.isWorship = true;
          let response = await this.verifyEligibility(eligibleParams);
          if(response) {
            isEligible = response.isEligible;
            this.eligibilityId = response.eligibilityId;
          }
        }
        if(!isEligible && this.isVolunteer) {
          let eligibleParams = {};
          eligibleParams.address1 = '';
          eligibleParams.city = '';
          eligibleParams.state = '';
          eligibleParams.zipCode = this.volunteerZipCode;
          eligibleParams.isVolunteer = true;
          let response = await this.verifyEligibility(eligibleParams);
          if(response) {
            isEligible = response.isEligible;
            this.eligibilityId = response.eligibilityId;
          }
        }
        if(!isEligible && this.familyEligibility) {
          isEligible = true;
        }
        if(!isEligible && this.isDonating) {
          isEligible = true;          
        }

        this.verifiyingEligibility = false;

        let ignoreEligibility = false;
        if(!isEligible) {
          console.info('member is not eligible');
          if((this.applicantEligibilityRequirement === 'Primary' || this.applicantEligibilityRequirement === 'All') && this.applicationEligibilityRequirement === this.preventSubmission) {
            ignoreEligibility = false;
          } else if((this.applicantEligibilityRequirement === 'Primary' || this.applicantEligibilityRequirement === 'All') && (this.applicationEligibilityRequirement === this.preventAutoApproval || this.applicationEligibilityRequirement === this.ignoreAndAddNote)) {
            ignoreEligibility = true;
          } else if(this.applicantEligibilityRequirement === 'None' && this.applicationEligibilityRequirement === this.preventSubmission) {
            ignoreEligibility = false;
          } else if(this.applicantEligibilityRequirement === 'None' && (this.applicationEligibilityRequirement === this.preventAutoApproval || this.applicationEligibilityRequirement === this.ignoreAndAddNote)) {
            ignoreEligibility = true;
          } else if(this.applicantEligibilityRequirement === 'Any' && this.applicationEligibilityRequirement === this.preventSubmission && !this.jointBorrower) {
            ignoreEligibility = false;
          } else if(this.applicantEligibilityRequirement === 'Any' && this.applicationEligibilityRequirement === this.preventSubmission && this.jointBorrower) {
            ignoreEligibility = true;
          } else if(this.applicantEligibilityRequirement === 'Any' && (this.applicationEligibilityRequirement === this.preventAutoApproval || this.applicationEligibilityRequirement === this.ignoreAndAddNote)) {
            ignoreEligibility = true;
          }
          console.log(`applicantEligibilityRequirement is ${this.applicantEligibilityRequirement}, applicationEligibilityRequirement is ${this.applicationEligibilityRequirement}, jointApplication is ${this.jointBorrower}, ...so ignore eligibility is ${ignoreEligibility}`);
        } else {
          console.info('member is eligible');
        }

        if(isEligible) {
          if(this.editMode) {
            if(this.contactInfoChanged && this.challengeQuestionsEnabled && !this.challengedQuestionsAnswered) {              
              this.$router.push({ name: 'challengequestions', params: { isPrimary: true }});
            } else {
              this.$router.push("review");
            }
          } else if(this.primaryReferenceRequired) {
            if(this.challengeQuestionsEnabled && !this.challengedQuestionsAnswered) {
              this.$router.push({ name: 'challengequestions', params: { isPrimary: true }});
            } else {
              this.$router.push("references");
            }
          } else if (this.jointBorrower) {
            if(this.challengeQuestionsEnabled && !this.challengedQuestionsAnswered) {
              this.$router.push({ name: 'challengequestions', params: { isPrimary: true }});
            } else { 
              this.$router.push("jointidentification");
            }
          } else {
            if(this.challengeQuestionsEnabled && !this.challengedQuestionsAnswered) {
              this.$router.push({ name: 'challengequestions', params: { isPrimary: true }});
            } else { 
              this.$router.push("review");
            }
          }
        } else if(ignoreEligibility) {
          if(this.challengeQuestionsEnabled && !this.challengedQuestionsAnswered) {
            this.$router.push({ name: 'challengequestions', params: { isPrimary: true }});
          } else if(this.challengeQuestionsEnabled && this.challengedQuestionsAnswered && this.contactInfoChanged) {
            this.$router.push({ name: 'challengequestions', params: { isPrimary: true }});
          } else {
            if(this.editMode) {
              this.$router.push("review");
            } else if(this.primaryReferenceRequired) {
              this.$router.push("references");
            } else if (this.jointBorrower) {
              this.$router.push("jointidentification");
            } else {
              this.$router.push("review");
            }
          }
        } else {
          if(this.challengeQuestionsEnabled && !this.challengedQuestionsAnswered) {
            this.$router.push({ name: 'challengequestions', params: { isPrimary: true }});
          } else if(this.challengeQuestionsEnabled && this.challengedQuestionsAnswered && this.contactInfoChanged) {
            this.$router.push({ name: 'challengequestions', params: { isPrimary: true }});
          } else {
            this.$refs.notEligibleModalRef.show();
          }
        }
      }
    },
    back() {
      if(this.editedIdentificationInfo || this.editedContactInfo) {
        this.$router.push('contactinformation');
      } else if(this.editMode) {
        this.$store.replaceState(this.currentState);
        this.$router.push("review");
      } else {
        this.$router.push('contactinformation');
      }
    },
  },
  validations: {
    isEmployed: {
      required
    },
    isStudent: {
      required,
    },
    attendsWorship: {
      required,
    },
    isVolunteer: {
      required,
    },
    familyEligibility: {
      required,
    },
    isDonating: {
      required
    },
    employerName: {
      required: requiredIf(function () {
        return this.isEmployed && this.employerAddressRequired;
      }),
    },
    address1: {
      required: requiredIf(function () {
        return this.isEmployed && this.employerAddressRequired;
      }),
    },
    city: {
      required: requiredIf(function () {
        return this.isEmployed && this.employerAddressRequired;
      }),
    },
    state: {
      required: requiredIf(function () {
        return this.isEmployed && this.employerAddressRequired;
      }),
    },
    employerZipCode: {
      required: requiredIf(function () {
        return this.isEmployed && this.employerAddressRequired;
      }),
      zipCodeValidation (value) {
        return zipCodeValidation(this.state)(value);
      },
      minLength: minLength(5)
    },
    employmentType: {
      required: requiredIf(function () {
        return this.isEmployed;
      }),
    },
    jobTitle: {
      required: requiredIf(function () {
        return this.isEmployed;
      }),
    },
    employmentStartDate: {
      required: requiredIf(function () {
        return this.isEmployed;
      }),
    },
    monthlyIncome: {
      required: requiredIf(function () {
        return this.isEmployed;
      }),
        decimal
    },
    additionalIncome: {
      required: requiredIf(function () {
        return this.isEmployed;
      }),
    },
    schoolName: {
      required: requiredIf(function () {
        return this.isStudent;
      }),
    },
    schoolZipCode: {
      required: requiredIf(function () {
        return this.isStudent;
      }),
      minLength: minLength(5)
    },
    worshipZipCode: {
      required: requiredIf(function () {
        return this.attendsWorship;
      }),
      minLength: minLength(5)
    },
    volunteerZipCode: {
      required: requiredIf(function () {
        return this.isVolunteer;
      }),
      minLength: minLength(5)
    },
    familyMemberName: {
      required: requiredIf(function () {
        return this.familyEligibility;
      }),
    },
    familyMemberRelationship: {
      required: requiredIf(function () {
        return this.familyEligibility;
      }),
    },
    donationAmount: {
      required: requiredIf(function () {
        return this.isDonating;
      }),
    },
    previousEmployments: {
      $each: {
        employerName: {
          required: requiredIf(function () {
            return this.isEmployed;
          }),
        },
        address1: {
          required: requiredIf(function () {
            return this.isEmployed;
          }),
          alphaNum
        },
        city: {
          required: requiredIf(function () {
            return this.isEmployed;
          }),
          alphaDash
        },
        state: {
          required: requiredIf(function () {
            return this.isEmployed;
          }),
        },
        zipCode: {
          required: requiredIf(function () {
            return this.isEmployed;
          }),
          zipCodeValidation (value, currItem) {
            return zipCodeValidation(currItem.state)(value);
          },
          minLength: minLength(5)
        },
        employmentType: {
          required: requiredIf(function () {
            return this.isEmployed;
          })
        },
        jobTitle: {
          required: requiredIf(function () {
            return this.isEmployed;
          })
        },
        employmentStartDate: {
          required: requiredIf(function () {
            return this.isEmployed;
          })
        },
        employmentEndDate: {
          required: requiredIf(function () {
            return this.isEmployed;
          })
        },
        monthlyIncome: {
          required: requiredIf(function () {
            return this.isEmployed;
          }),
          decimal
        },
      }
    },
    additionalIncomeSources: {
      $each: {
        income: {
          required: requiredIf(function () {
            return this.isEmployed;
          })
        },
        amount: {
          required: requiredIf(function () {
            return this.isEmployed;
          }),
          decimal
        },
      }
    }
  }
};
</script>